import { styled } from "../../../styled-components";

export const SignatureFieldViewStyle = styled.div`
    padding: ${p => (p.theme.navBar.style === "iOS" ? 3 : 12)}px ${p => p.theme.pageMarginMedium}px 12px;

    .sf-inner {
        position: relative;
        display: flex;
        flex-direction: column;

        padding-top: 9px;
        padding-left: ${p => (p.theme.navBar.style === "iOS" ? 0 : 12)}px;
        padding-right: ${p => (p.theme.navBar.style === "iOS" ? 0 : 12)}px;
        padding-bottom: 1px;

        border-top-left-radius: 4px;
        border-top-right-radius: 4px;

        background-color: ${p => (p.theme.navBar.style === "iOS" ? "transparent" : p.theme.offBaseColor)};
        border-bottom-color: ${p => p.theme.textField.underlineColor};
        border-bottom-width: 1px;
        border-bottom-style: solid;

        color: ${p => p.theme.fgColorMedium};

        .sf-title-container {
            display: flex;
            padding-top: 8px;
            margin-bottom: 4px;

            .sf-title {
                flex-grow: 1;
                color: ${p => p.theme.fgColorMedium};
                font-size: 14px;
                font-weight: 500;
            }

            .sf-clear-icon {
                width: 24px;
                height: 24px;

                display: flex;
                justify-content: flex-end;
                align-items: flex-start;

                color: ${p => p.theme.fgColorLight};

                cursor: pointer;

                :hover {
                    opacity: 0.5;
                }
            }
        }

        .sf-placeholder {
            color: ${p => p.theme.fgColorLight};
            font-size: 18px;
            margin-bottom: 8px;
            object-fit: contain;
            width: 100%;
            max-height: 250px;

            filter: invert(${p => (p.theme.signature.invert ? 1 : 0)});
        }
    }
`;
